export interface FieldSchema {
  /** Expected top-level field names */
  fields: string[];
  /** Expected keys inside nested object fields (one level down) */
  nested?: Record<string, string[]>;
  /** Expected keys inside each item of array fields (one level down) */
  arrayItem?: Record<string, string[]>;
}

export const PAGE_TYPE_SCHEMAS: Record<string, FieldSchema> = {
  pdp: {
    fields: [
      `selected`,
      `productTitle`,
      `productDescription`,
      `productGender`,
      `products`,
      `recommendedProducts`
    ],
    nested: {
      selected: [`styleColor`, `size`]
    },
    arrayItem: {
      products: [`styleColor`, `colorDescription`, `availableSizes`]
    }
  }
};
